// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.yi2ET{width:100%;display:flex;flex-direction:row;align-items:center;gap:12px}.CeJe9{width:100%;display:flex;flex-direction:column;gap:12px}.qPFDk{background-color:#fcfcfd}.mycQB{flex-shrink:0;width:120px}.g4jVe{display:flex;flex-direction:column}.xP7gv{display:flex;flex-direction:row;align-items:center;margin-top:28px}.xP7gv.lMOuG{display:block}.O2lHa{width:100%;text-align:start}.DLvzr{display:flex;align-items:center;gap:12px}.lMOuG .DLvzr{justify-content:space-between;margin-bottom:8px}.pKXVr{display:flex;flex-direction:column;text-align:left;max-width:180px;flex-shrink:0}.UjGhN{background-color:#fcfcfd;width:360px}.Ss3DZ{width:100%;display:flex;justify-content:flex-end}.Qtyrt{margin-top:30px;text-align:left}.CYdku{min-width:118px;text-align:left;margin:0 4px 0 12px}.lMOuG .CYdku{min-width:0}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"blue45": `#fcfcff`,
	"blue48": `#f5f7fd`,
	"blue50": `#f3f5ff`,
	"blue300": `#dae0ff`,
	"blue500": `#c0caff`,
	"blue600": `#a1aef5`,
	"blue700": `#8296ff`,
	"blue800": `#6176e7`,
	"dark50": `#fcfcfd`,
	"dark70": `#f4f4f7`,
	"dark100": `#eaeaef`,
	"dark120": `#e4e4ec`,
	"dark200": `#d4d4e0`,
	"dark300": `#bfbfd0`,
	"dark400": `#a9a9c1`,
	"dark500": `#9393b1`,
	"dark600": `#7e7ea1`,
	"dark700": `#696992`,
	"dark800": `#535382`,
	"dark900": `#282863`,
	"green45": `#eff6fa`,
	"green50": `#f3fcfa`,
	"green300": `#b6ebdf`,
	"green500": `#86ddca`,
	"green700": `#56d0b5`,
	"green800": `#36b89b`,
	"green900": `#089475`,
	"orange50": `#fdf2dc`,
	"orange300": `#fadea8`,
	"orange500": `#f9d797`,
	"orange700": `#f7ca75`,
	"orange800": `#f5bd52`,
	"orange900": `#dd9306`,
	"purple50": `#e1d9fe`,
	"purple300": `#c3b3fc`,
	"purple500": `#a58efb`,
	"purple700": `#8768f9`,
	"purple800": `#6942f8`,
	"purple900": `#4520cc`,
	"red200": `#fdf0f0`,
	"red300": `#fee3e3`,
	"red500": `#f9d5d5`,
	"red700": `#f3aaaa`,
	"red900": `#eb7272`,
	"red950": `#e86161`,
	"red970": `#dd4c4c`,
	"white": `#fff`,
	"defaultTextStandard": `#282863`,
	"defaultTextSecondary": `#696992`,
	"defaultButtonPrimary": `#6942f8`,
	"buttonPrimary": `var(--button-primary, #6942f8)`,
	"buttonPrimaryDark": `var(--button-primary-dark, #4520cc)`,
	"buttonDisabled": `var(--button-disabled, #bfbfd0)`,
	"buttonDisabledDark": `var(--button-disabled-dark, #a9a9c1)`,
	"defaultButtonDisabled": `#bfbfd0`,
	"defaultStepperCompleted": `#089475`,
	"defaultStepperIncomplete": `#d4d4e0`,
	"defaultButtonSecondary": `#fcfcfd`,
	"defaultBgStandard": `#f3f5ff`,
	"defaultBgLight": `#fff`,
	"root": `yi2ET`,
	"multipleRecipientsRoot": `CeJe9`,
	"input": `qPFDk`,
	"button": `mycQB`,
	"linksContainer": `g4jVe`,
	"linkRow": `xP7gv`,
	"mobile": `lMOuG`,
	"title": `O2lHa`,
	"recipientDetails": `DLvzr`,
	"reviewerDetails": `pKXVr`,
	"link": `UjGhN`,
	"linkWrapper": `Ss3DZ`,
	"additionalRecipientsTitle": `Qtyrt`,
	"badge": `CYdku`
};
export default ___CSS_LOADER_EXPORT___;
